import { IRecipe } from "interfaces/recipe.interface";
import { Swiper, SwiperSlide } from "swiper/react";
import { Lazy, Navigation } from "swiper";
import "swiper/css";
import RecipeCard from "components/recipeCard/recipeCard";
import { Skeleton } from "@mui/material";
import "swiper/css/navigation";
import cls from "./recipesListSwiper.module.scss";

type Props = {
  title?: string;
  data?: IRecipe[];
  loading?: boolean;
};

export default function RecipeListSwiper({
  title,
  data,
  loading = false,
}: Props) {
  if (!loading && !data?.length) {
    return null;
  }
  const renderView = () => {
    if (loading) {
      return Array.from(new Array(6)).map((_, idx) => (
        <SwiperSlide key={`recipes_${idx}`} className={cls.swiperSlide}>
          <div className={cls.item}>
            <Skeleton variant="rectangular" className={cls.shimmer} />
          </div>
        </SwiperSlide>
      ));
    }
    if (!data?.length) {
      return;
    }
    return data?.map((item) => (
      <SwiperSlide key={item?.id} className={cls.swiperSlide}>
        <div className={cls.item}>
          <RecipeCard data={item} />
        </div>
      </SwiperSlide>
    ));
  };

  return (
    <div className={cls.container}>
      {!!title && <h2 className={cls.title}>{title}</h2>}
      <Swiper
        navigation
        lazy
        modules={[Navigation, Lazy]}
        slidesPerView="auto"
        className={cls.swiper}
        spaceBetween={12}
      >
        {renderView()}
      </Swiper>
    </div>
  );
}
